// export const BACKEND_URL = process.env.BACKEND_URL || 'http://localhost:3002';
export const BACKEND_URL = 'https://sleepy-plateau-69754.herokuapp.com';
// https://sleepy-plateau-69754.herokuapp.com/
// process.env.BACKEND_URL || 'http://localhost:3002'
